import { createAction, props } from '@ngrx/store';

export const setLocationSearchText = createAction(
	'[Locations] Search locations by name',
	props<{
		searchText: string;
	}>()
);
